import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { BaseCardModal } from 'reservations/checklessPayments/components/BaseCardModal';
import { SaveChecklessButton } from 'reservations/checklessPayments/components/SaveChecklessButon';
import { SaveNewPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';
import { REPLACE_YOUR_CARD_HEADER } from 'reservations/checklessPayments/constants';

const UpdateCardModal = () => {
  const { close, setModalContext } = useModal();
  const hasVisitId = useHasVisitId();

  const handleSaveFailed = () => {
    setModalContext({ cardDeclinedError: true });
  };

  return (
    <BaseCardModal
      headerText={REPLACE_YOUR_CARD_HEADER}
      Button={hasVisitId ? SaveChecklessButton : SaveNewPaymentButton}
      handleClick={close}
      handleSaveFailed={handleSaveFailed}
    />
  );
};

export default UpdateCardModal;
